export const LogoMarquee = () => {
  const logos = [
    { src: "/Partners/Neom-Logo.png", alt: "NEOM" },
    { src: "/Partners/Red_Sea_Global.png", alt: "Red Sea Global" },
    { src: "/Partners/Qiddiya.png", alt: "Qiddiya" },
    { src: "/Partners/Amaala.png", alt: "AMAALA" },
    { src: "/Partners/Al_Ula_Development_Company_Logo.svg.png", alt: "Al-Ula" },
    { src: "/Partners/Saudi_Arabia_2034_FIFA_World_Cup_bid_logo.svg.png", alt: "FIFA World Cup 2034" },
    { src: "/Partners/AFC_Asian_Cup.png", alt: "AFC Asian Cup 2027" },
    { src: "/Partners/AsianGamesKSA.png", alt: "Asian Winter Games" },
    { src: "/Partners/Diriyah_Seal.png", alt: "Diriyah Season" },    
    { src: "/Partners/RiyadhEXPOLogo.png", alt: "Riyadh Expo 2030" },
    { src: "/Partners/FormulaSaudiArabia.png", alt: "Formula 1 Saudi Arabian Grand Prix" },
  ];

  return (
    <div className="relative flex overflow-hidden bg-white shadow-sm rounded-xl p-6">
      <div className="flex animate-marquee whitespace-nowrap">
        {logos.map((logo, index) => (
          <div
            key={index}
            className="flex items-center justify-center mx-12 w-[200px]"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              className="max-h-16 w-auto object-contain hover:opacity-75 transition-opacity duration-300"
            />
          </div>
        ))}
        {logos.map((logo, index) => (
          <div
            key={`duplicate-${index}`}
            className="flex items-center justify-center mx-12 w-[200px]"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              className="max-h-16 w-auto object-contain hover:opacity-75 transition-opacity duration-300"
            />
          </div>
        ))}
      </div>
    </div>
  );
};